import { MouseEvent, FunctionComponent, createElement } from 'react';
import DOMPurify from 'dompurify';

type DangerHtmlProps = {
    className?: string;
    html: string;
    onClick?: (event: MouseEvent) => void;
    isToSanitize?: boolean;
    tag?: string;
};

const DangerHtml: FunctionComponent<DangerHtmlProps> = ({
    className,
    html,
    onClick,
    isToSanitize,
    tag,
}) => {
    return createElement(tag || 'span', {
        className,
        onClick,
        dangerouslySetInnerHTML: {
            __html:
                isToSanitize === false ? html : DOMPurify.sanitize(html, { ADD_ATTR: ['target'] }),
        },
    });
};

export default DangerHtml;
